import axios, { AxiosResponse } from "axios";
import { Weather } from '~/api/models/weather.model';
import { Location } from "../models/location.model";
import { Pollution } from '~/api/models/pollution.model';
import { List } from '~/api/models/list.model';
import { Recommandation } from '~/api/models/recommandation.model';
import { http } from '~/api/api-http';
import { useConfigStore } from "~/store/configuration.store";

export class WeatherService {

    private static  _instance: WeatherService | null = null;

    static getInstance(): WeatherService {
        if(!WeatherService._instance) {
            WeatherService._instance = new WeatherService();
        }
        return WeatherService._instance;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {
    }

    readonly APP_ID: string = '730ba8b01c29817992e950cd5bc262f4';

    getWeather(location: Location, lang: string = 'fr', ): Promise<Weather> {

        if(!location) {
            return Promise.resolve(null);
        }

        return axios.get<Weather>(
            'https://api.openweathermap.org/data/2.5/onecall',
            { 
                params: {
                    lang,
                    appid: this.APP_ID,
                    units: 'metric',
                    lat: location.lat,
                    lon: location.lon,
                },
            })
            .then((response: AxiosResponse<Weather>) => {
                return response.data;
            })
            .catch((error) => {
                console.error(`Could not load weather`, error);
                return null;
            })
    }

    getCurrentPollution(location: Location): Promise<Pollution> {
        if(!location) {
            return Promise.resolve(null);
        }
        const configStore = useConfigStore();
        return http.get<Pollution>(
            '/v0/now',
            {
                baseURL: configStore.apiEndpoint,
                params: {
                    lon: location.lon,
                    lat: location.lat,
                    aqi: "elichens",
                }
            }
        ).then((response: AxiosResponse<Pollution>) => response.data);
    }

    getRecommandations(locale: string = 'en'): Promise<List<Recommandation>> {
        return http.get<List<Recommandation>>('/api/contents/aqi', { params: { lang: locale}})
            .then((response: AxiosResponse<List<Recommandation>>) => response.data);
    }
}